export var SocialMediaProviders;

(function (SocialMediaProviders) {
  SocialMediaProviders["ActiveDirectory"] = "ActiveDirectory";
  SocialMediaProviders["Apple"] = "Apple";
  SocialMediaProviders["Facebook"] = "Facebook";
  SocialMediaProviders["Google"] = "Google";
  SocialMediaProviders["VKontakte"] = "VKontakte";
  SocialMediaProviders["WeChat"] = "WeChat";
})(SocialMediaProviders || (SocialMediaProviders = {}));